import type { OpenAPIV3_1 as OpenAPIV31 } from 'openapi-types';

import type { OasWebPages } from './OasWebPages';

export type BaseOasDocumentObjectExtension = {
  'x-webPages'?: OasWebPages;
};

export type OasDocumentObject3XExtension = BaseOasDocumentObjectExtension & {
  info: OpenAPIV31.InfoObject;
};
